import { render, staticRenderFns } from "./marketSocialAccount.vue?vue&type=template&id=51e9b9f4&scoped=true&"
import script from "./marketSocialAccount.vue?vue&type=script&lang=js&"
export * from "./marketSocialAccount.vue?vue&type=script&lang=js&"
import style0 from "./marketSocialAccount.vue?vue&type=style&index=0&id=51e9b9f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e9b9f4",
  null
  
)

export default component.exports